import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import EpButton from '../../components/EpButton';
import EpHighlightIndicator from '../../components/EpHighlightIndicator';
import EpSponsorsSlider from '../../components/EpSponsorsSlider';
import EpAlert from '../../components/EpAlert';
import PadlockIcon from '../../assets/icons/padlock.svg';
import RegistersIndicatorImage from '../../assets/icons/indicators/indicator_registers.svg';
import ICUsIndicatorImage from '../../assets/icons/indicators/indicator_icus.svg';
import CountriesIndicatorImage from '../../assets/icons/indicators/indicator_countries.svg';
import indicatorsService from '../../services/indicatorsService';
// eslint-disable-next-line max-len
// import AdmissionsIndicatorImage from '../../assets/icons/indicators/indicator_admissions.svg';
import authService from '../../services/authService';
import EpLoadingPage from '../../components/EpLoadingPage';
import EpToaster from '../../components/EpToaster';
import filterService from '../../services/filterService';
import useTranslation from '../../hooks/useTranslation';
import EpGlobalFooter from '../../components/EpGlobalFooter';
import './styles.scss';

const Login = () => {
  const history = useHistory();
  const currentUserLanguage = localStorage.getItem('bi.userLanguage');
  const isLoadingAuthentication = useSelector(state => state.auth.isLoadingAuthentication);
  const isAuthorizedUser = useSelector(state => state.auth.isAuthorizedUser);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  // Tags do Globalization
  const InternationalBenchmarking = currentUserLanguage === 'pt-BR'
    ? 'Benchmarking <span class="project__title--highlight">Internacional</span>'
    : 'International <span class="project__title--highlight">Benchmarking</span>';
  const InternationalBenchmarkingDescription = useTranslation('An independent consortium of ICU registries to promote quality improvement, research and benchmaking in intensive care.');
  const Enter = useTranslation('enter');
  const Registry = useTranslation('Registry');
  const ICUs = useTranslation('ICUs');
  const Countries = useTranslation('Countries');
  // const Admissions = useTranslation('Admissions');
  const Participants = useTranslation('Participants');

  const AccessDenied = useTranslation('Access denied');
  const ThePageIsRestrictedAndItCannotBeShown = useTranslation('The page is restricted and it cannot be shown.');
  const [indicators, setIndicators] = useState([
    {
      id: 1,
      value: null,
      description: Registry,
      iconPath: RegistersIndicatorImage,
      iconAlt: 'Ícone de registros',
    },
    {
      id: 2,
      value: null,
      description: Countries,
      iconPath: CountriesIndicatorImage,
      iconAlt: 'Ícone de países',
    },
    {
      id: 3,
      value: null,
      description: ICUs,
      iconPath: ICUsIndicatorImage,
      iconAlt: 'Ícone de UTIs',
    },
  ]);

  useEffect(() => {
    authService().defineSigninMethod();
  }, []);

  const updateIndicators = (apiData) => {
    const updatedIndicators = indicators.map((indicator) => {
      const updatedIndicator = { ...indicator };

      if (indicator.id === 1) {
        updatedIndicator.value = apiData.registryCount;
        updatedIndicator.description = Registry;
      } else if (indicator.id === 2) {
        updatedIndicator.value = apiData.countryCount;
        updatedIndicator.description = Countries;
      } else if (indicator.id === 3) {
        updatedIndicator.value = apiData.icuCount;
        updatedIndicator.description = ICUs;
      }

      return updatedIndicator;
    });

    setIndicators([]);
    setIndicators(updatedIndicators);
  };

  useEffect(() => {
    const fetchAndUpdateIndicators = async () => {
      if (isAuthorizedUser && !isLoadingAuthentication) {
        try {
          const apiResponse = await indicatorsService().getLoginTotalizer();
          updateIndicators(apiResponse.data.response);
        } catch (error) {
          console.error('Failed to fetch indicator data:', error);
        }
      }
    };

    fetchAndUpdateIndicators();
  }, [isAuthorizedUser, isLoadingAuthentication]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoadingPage(isLoadingAuthentication);
    }, 200);
  }, [isLoadingAuthentication]);

  // Insere traduções com html nos lugares corretos
  useEffect(() => {
    document.getElementById('login-page__title').innerHTML = InternationalBenchmarking;
    document.getElementById('login-page__description--bi').innerHTML = InternationalBenchmarkingDescription;
  }, [currentUserLanguage, InternationalBenchmarkingDescription]);

  const handleGoToDefaultIndicatorsPage = async (e) => {
    e.preventDefault();
    setIsLoadingPage(true);

    // Faz chamada dos dados inicias dos filtros para benchmarking
    const lastCacheTime = null;
    const filterCache = {
      years: null,
      patientsGroups: null,
    };

    await filterService().getInitialBenchmarkingFiltersData(
      currentUserLanguage, filterCache, lastCacheTime,
    );

    history.push({
      pathname: '/benchmarking',
    });

    setIsLoadingPage(false);
  };

  return (
    <>
      <EpToaster />

      <EpLoadingPage isVisible={isLoadingPage} />

      <div id="login-page">
        <div className="container login-page__container">
          <div className="login-page__introduction">
            {/* Bloco esquerdo */}
            <div className="login-page__introduction--left col-lg-6 col-md-12">
              <h1 id="login-page__title" className="project__title"> </h1>
              <div className="login-page__button-wrapper">
                {isAuthorizedUser ? (
                  <EpButton
                    actionType="button"
                    buttonText={Enter}
                    onClickFunc={e => handleGoToDefaultIndicatorsPage(e)}
                    disabled={!isAuthorizedUser || isLoadingAuthentication}
                    buttonType="primary"
                    buttonWidthType="fullsize"
                    buttonSize="lg"
                    customClass=""
                  />
                ) : (
                  <EpAlert
                    customId="alert--access-denied"
                    alertType="warning"
                    icon={<img alt="Ícone de cadeado" src={PadlockIcon} />}
                    title={AccessDenied}
                    description={ThePageIsRestrictedAndItCannotBeShown}
                  />
                )}
              </div>

            </div>

            {/* Bloco direito */}
            <div className="login-page__introduction--right col-lg-6 col-md-12">
              <p id="login-page__description--bi" className="login-page__description"> </p>

              {/* Seção dos indicadores */}
              <div className="indicators">
                {indicators.map(indicator => (
                  <EpHighlightIndicator
                    key={indicator.id}
                    value={!isLoadingAuthentication && isAuthorizedUser ? indicator.value : null}
                    valueSymbol={indicator.id === 4 ? '+' : ''}
                    valueDigits={0}
                    description={indicator.description}
                    iconPath={indicator.iconPath}
                    iconAlt={indicator.iconAlt}
                    currentUserLanguage={currentUserLanguage}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Bloco de Slider de Participantes */}
          <section className="participants col-12">
            <h3 className="participants__title">{Participants}</h3>
            <div className="participants__slider-wrapper">

              <EpSponsorsSlider />
            </div>
          </section>

          {/* Bloco de Patrocinadores */}
          <EpGlobalFooter login />
        </div>
      </div>
    </>
  );
};

export default Login;
